<template>
  <div class="home">
    <header>
      <img src="../assets/home-decoration/bague-color-rouge.png" alt="" class="bg-img bg-img1" data-speed="0.6">
      <img src="../assets/home-decoration/header-2.png" alt="" class="bg-img bg-img2" data-speed="0.8">
      <img src="../assets/home-decoration/header-3.png" alt="" class="bg-img bg-img3" data-speed="1.2">
      <div class="front" data-speed="0.9">
        <h1>{{ t("headerTitle") }}</h1>
        <router-link to="/bagues" class="link"><div class="line"></div>{{ t("discover") }}</router-link>
      </div>
      <img data-speed="1.2" src="../assets/home-decoration/bleue.png" alt="" class="front-img">
    </header>
    <section data-speed="0.8">
      <h2>{{ t("ringsTitle") }}</h2>
      <p>{{ t("ringsText") }}</p>
      <router-link  to="/bagues" class="link section-link"><div class="line"></div>{{ t("discover") }}</router-link>
      <img data-speed="1.2" src="../assets/home-decoration/bague.png" alt="">
    </section>
    <div class="right-aligner">
      <section>
        <h2>{{ t("chronosTitle") }}</h2>
        <p>{{ t("chronosText") }}</p>
        <router-link  to="/chronographes" class="link section-link"><div class="line"></div>{{ t("discover") }}</router-link>
        <img data-speed="1.2" src="../assets/home-decoration/chrono.png" alt="">
      </section>
    </div>
    <section class="history-section"> 
      <h2>{{ t("historyTitle") }}</h2>
      <p>{{ t("historyText") }}</p>
      <router-link to="/history" class="link section-link"><div class="line"></div>{{ t("discover") }}</router-link>
    </section>
  </div>
</template>
<script setup>
import { useLangStore } from '@/stores/langStore'

const langStore = useLangStore()

const translations = {
  fr: {
    headerTitle: "Holy, une touche colorée signée berney",
    discover: "Découvrir",
    ringsTitle: "Nos bagues",
    ringsText: "Nos modèles intemporels comme la Classique aux pièces plus audacieuses comme la Panda, nos montres-bagues incarnent une vision contemporaine de l’horlogerie, respectueuse de l’héritage mais tournée vers l’avenir",
    chronosTitle: "Nos chronographes",
    chronosText: "Au cœur de nos chronographes bat un trésor mécanique : des mouvements Valjoux 23 et Valjoux 88, préservés depuis les années 70 et soigneusement remontés avec leurs composants d’époque. Ces calibres mythiques, emblématiques de l’âge d’or du chronographe suisse, retrouvent une seconde vie grâce au savoir-faire de notre atelier",
    historyTitle: "L'histoire de la maison",
    historyText: "Dans l’atelier Berney de L’Abbaye, chaque geste d’artisan raconte une histoire. Un processus minutieux transforme les matériaux les plus nobles en une œuvre intemporelle."
  },
  en: {
    headerTitle: "Holy, a colorful touch by berney",
    discover: "Discover",
    ringsTitle: "Our rings",
    ringsText: "From our timeless models like the Classique to bolder pieces like the Panda, our ring-watches embody a contemporary vision of watchmaking—respectful of heritage yet oriented towards the future.",
    chronosTitle: "Our chronographs",
    chronosText: "At the heart of our chronographs beats a mechanical treasure: Valjoux 23 and Valjoux 88 movements, preserved since the 1970s and carefully reassembled with their original components. These legendary calibres, emblematic of the golden age of Swiss chronographs, are given a second life thanks to the expertise of our workshop.",
    historyTitle: "The history of the maison",
    historyText: "In the Berney workshop in L’Abbaye, every artisan’s gesture tells a story. A meticulous process transforms the finest materials into a timeless work of art."
  }
}

const t = (key) => {
  return translations[langStore.currentLanguage][key] || key
}

</script>

<style scoped>

.spacer {
  height: 200vh;
}

header {
  height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: end;
  align-items: flex-start;
  padding-left: 160px;
  margin-bottom: 300px;
}

h1 {
  font-family: 'Noto Serif', serif;
  text-transform: uppercase;
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 30px;
  max-width: 60%;
}

.front {
  position: relative;
  z-index: 1;
}

.front-img {
  position: absolute;
  right: 10%;
  top: 20%;
  width: 600px;
}

.bg-img {
  position: absolute;
  z-index: 0;
}

.bg-img1 {
  width: 25%;
  top: 100px;
  left: 200px;
}

.bg-img2 {
  width: 20%;
  right: 0;
  top: 40px;
}

.bg-img3 {
  bottom: -15%;
  left: 20%;
}

.link {
    text-transform: uppercase;
    font-size: 14px;
    display: flex;
    align-items: baseline;
    transition: all .3s ease;
    margin-bottom: 15px;
  }
.line {
    height: 20px;
    width: 40px;
    margin-right: 10px;
    border-bottom: 1.5px solid #000;
    transition: all .3s ease;
  }
.link:hover .line {
    width: 25px;
    margin-left: 15px;
    opacity: .7;
  }
 
  .link:hover {
    opacity: .7;
  }

  section {
    margin: 0 250px 200px 250px;
    max-width: 35%;
    position: relative;
  }
  
  .right-aligner {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  h2 {
    position: relative;
    font-family: 'Noto Serif', serif;
    text-transform: uppercase;
    font-size: 45px;
    font-weight: 700;
    margin-bottom: 20px;
    z-index: 1;
  }

  p {
    position: relative;
    font-size: 18px;
    margin-left: 100px;
    font-weight: 300;
    margin-bottom: 70px;
    z-index: 1;
  }

  .section-link {
    position: relative;
    z-index: 1;
  }

  section img {
    max-width: 70%;
    position: absolute;
    top: 0;
    right: -50%;
  }

  .right-aligner section img {
    left: -40%;
  }

  .history-section {
    display: flex;
    flex-direction: column;
    align-items: center;
     max-width: 100%;  
    margin-top: 200px;
    padding-bottom: 100px;
  }

  .history-section p {
    margin-left: 0;
  }

  .history-section * {
    text-align: center;
  }

    @media screen and (max-width: 768px) {
    header {
      padding-left: 60px;
      margin-bottom: 200px;
      height: 110vh;
    }

    h1 {
      font-family: 'Noto Serif', serif;
      text-transform: uppercase;
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 30px;
      max-width: 60%;
    }
    h2 {
      font-size: 30px;
    }
    .link {
      text-transform: uppercase;
      font-size: 14px;
      display: flex;
      align-items: baseline;
      transition: all .3s ease;
      margin-bottom: 150px;
    }

    .front-img {
      position: absolute;
      right: 0;
      top: 30%;
      width: 500px;
    }
    .bg-img1 {
      width: 45%;
      top: 150px;
      left: 10px;
    }

    .bg-img2 {
      width: 50%;
      right: 0;
      top: 40px;
    }

    .bg-img3 {
      bottom: 0;
      left: 20%;
      width: 50%;
    }
    section {
    margin: 0 100px 100px 100px;
    max-width: 50%;
    position: relative;
  }
  .history-section {
    width: 80%;
    margin: 100px 10%; 
    padding-bottom: 100px;
  }
  }
  @media screen and (max-width: 435px) {
    header {
      padding-left: 20px;
      margin-bottom: 50px;
      height: 120vh;
    }

    h1 {
      font-family: 'Noto Serif', serif;
      text-transform: uppercase;
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 30px;
      max-width: 80%;
    }
    
    .link {
      text-transform: uppercase;
      font-size: 14px;
      display: flex;
      align-items: baseline;
      transition: all .3s ease;
      margin-bottom: 150px;
    }

    .front-img {
      position: absolute;
      right: -10%;
      top: 35%;
      width: 350px;
    }
    .bg-img1 {
      width: 45%;
      top: 200px;
      left: 10px;
    }

    .bg-img2 {
      width: 50%;
      right: 0;
      top: 40px;
    }

    .bg-img3 {
      bottom: 0;
      left: 20%;
      width: 50%;
    }
    section {
    margin: 0 20px 70px 20px;
    max-width: 80%;
    position: relative;
  }
  .history-section {
    width: 80%;
    margin: 50px 10%; 
    padding-bottom: 50px;
  }
  }

</style>